import { Image } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import SearchHomesSVG from '../../../../images/SearchHomes.svg';
import { StyledFixedHeightFlex } from '../StyledComponents';

const NotEnoughComps = () => (
  <StyledFixedHeightFlex display="flex" justifyContent="center" alignItems="center" flexDirection="column">
    <Image src={SearchHomesSVG} alt="" />
    <Text textStyle="body-sm" css={{ color: 'text.subtle', marginTop: '400' }}>
      Not enough information available
    </Text>
  </StyledFixedHeightFlex>
);

export default NotEnoughComps;
